export class IndicatorData {
  constructor(private readonly key: string, private readonly value: any) {}

  getKey(): string {
    return this.key;
  }

  getValue(): any {
    return this.value;
  }
}
